
export const clientesHeaders: string[] = [
  'CodigoEmpresa',
  'ClienteOProveedor',
  'CodigoClienteProveedor',
  'SiglaNacion',
  'CifDni',
  'CifDniRepresentante',
  'CodigoCategoriaCliente_',
  'CifEuropeo',
  'Nombre',
  'Nombre1',
  'Nombre2',
  'RazonSocial',
  'RazonSocial2',
  'ViaPublica',
  'Numero1',
  'Numero2',
  'Escalera',
  'Piso',
  'Puerta',
  'Letra',
  'Domicilio',
  'CodigoPostal',
  'CodigoMunicipio',
  'Municipio',
  'CodigoProvincia',
  'Provincia',
  'CodigoNacion',
  'Nacion',
  'Telefono',
  'Telefono2',
  'Telefono3',
  'Fax',
  'Email1',
  'Email2',
  'CodigoBanco',
  'CodigoAgencia',
  'DC',
  'CCC',
  'IBAN',
  'NumeroPlazos',
  'DiasPrimerPlazo',
  'DiasEntrePlazos',
  'DiasFijos1',
  'DiasFijos2',
  'DiasFijos3',
  'DiasRetroceso',
  'InicioNoPago',
  'FinNoPago',
  'ControlarFestivos',
  'MesesComerciales',
  'Cargo1',
  'Cargo2',
  'CodigoCanal',
  'CodigoComisionista',
  'CodigoCondiciones',
  'CodigoCuenta',
  'CodigoCuentaEfecto',
  'CodigoCuentaImpagado',
  'CodigoDepartamento',
  'CodigoIdioma_',
  'CodigoIva',
  'CodigoMotivoBajaClienteLc',
  'CodigoRetencion',
  'CodigoSigla',
  'CodigoTerritorio',
  'CodigoTipoEfecto',
  'CodigoTransaccion',
  'ColaMunicipio',
  'Contrapartida',
  'Deducible',
  'Exclusion347',
  'FechaNacimiento',
  'IdDelegacion',
  'MarcaMenorSinNif',
  'MotivoBajaClienteLc',
  'NombreRepresentante',
  'PersonaFisicaJuridica',
  'PuntosSR',
  'RemesaHabitual',
  'SiglaNacionRepresentante',
  'TarifaDescuento',
  'TarifaPrecio',
  'TarjetaSR',
  'TipoCif',
  'TipoDocumentoPersona',
  '%Descuento',
  '%Financiacion',
  '%ProntoPago',
  '%Rappel',
  'Comentario'
];

export const asientosHeaders: string[] = ['CodigoEmpresa', 'Ejercicio', 'NumeroPeriodo', 'FechaAsiento', 'CodigoCuenta', 'Asiento', 'Comentario', 'Tipo', 'Documento', 'CargoAbono', 'ImporteAsiento', 'Descripcion1'];

export const planHeaders: string[] = ['CodigoEmpresa', 'CodigoCuenta', 'Cuenta', 'ClienteOProveedor'];

const ACCOUNTING_ACCOUNT_SHIFT = 50000;

/**
 * Estadísticas de registros excluidos por cada filtro
 */
export interface ExclusionStats {
  devDocuments: number;  // Documentos con DEV_F o DEV_T
  total: number;
}

/**
 * Parsea el campo Name que viene en formato "TELEFONO - NOMBRE"
 * y extrae solo las partes del nombre (el teléfono se obtiene de la columna Phone)
 */
const parseNameAndPhone = (nameField: string): { nombre: string, nombre1: string, nombre2: string, razonSocial: string } => {
  if (!nameField) {
    return { nombre: '', nombre1: '', nombre2: '', razonSocial: '' };
  }

  let nombreCompleto = nameField.trim();

  // Si hay separador " - ", tomar solo la parte después (el nombre sin teléfono)
  const separatorIndex = nameField.indexOf(' - ');
  if (separatorIndex > -1) {
    nombreCompleto = nameField.substring(separatorIndex + 3).trim();
  }

  // Dividir el nombre en palabras
  const palabras = nombreCompleto.split(/\s+/).filter(p => p.length > 0);

  const nombre = palabras[0] || '';
  const nombre1 = palabras[1] || '';
  const nombre2 = palabras.length > 2 ? palabras.slice(2).join(' ') : '';
  const razonSocial = palabras.join(' ');

  return { nombre, nombre1, nombre2, razonSocial };
}

/**
 * Convierte una fecha de Excel (número) a año y mes
 * Las fechas de Excel son días desde 1900-01-01
 */
const getYearAndMonthFromExcelDate = (excelDate: any): { ejercicio: string, periodo: string } => {
  if (typeof excelDate !== 'number' || isNaN(excelDate)) {
    return { ejercicio: '', periodo: '' };
  }

  // Convertir fecha de Excel a JavaScript
  // Excel: días desde 1900-01-01 (con ajuste para compatibilidad con bug de Excel)
  const jsDate = new Date((excelDate - 25569) * 86400 * 1000);

  const year = jsDate.getFullYear().toString();
  const month = (jsDate.getMonth() + 1).toString();

  return { ejercicio: year, periodo: month };
}

const getAccountFromClientAccount = (account: any) => {
  if (account && account?.toString().length >= 8) {
    return parseInt(`${account.toString().substring(0, 3)}00000`);
  }
  return account;
}

const getShiftedAccount = (account: any) => {
  if (typeof account === 'number') {
    if (account.toString().startsWith('4300') && account > 43000000) {
      return account + ACCOUNTING_ACCOUNT_SHIFT;
    } else {
      return account;
    }
  } else {
    return '';
  }
}

/**
 * Detecta si un registro es de desarrollo (contiene DEV-F o DEV-T)
 */
const isDevDocument = (description: string, document: string): boolean => {
  const normalizedDesc = description.toUpperCase();
  const normalizedDoc = document.toUpperCase();
  return normalizedDesc.includes('DEV-F') ||
         normalizedDesc.includes('DEV-T') ||
         normalizedDoc.includes('DEV-F') ||
         normalizedDoc.includes('DEV-T');
}

export function convertClientes(data: Array<Record<string, any>>): { convertedData: Array<Record<string, any>>, rejectedRecords: Array<{ reason: string, data: Record<string, any> }> } {
  /*
  x Account: 43000012
  Accumulate in form 347: "Yes"
  Address: "Mi calle"
  City: "Miciudad"
  Contact type: "Person"
  x Country: "ES"
  x Country code: "ES"
  Created: 45706.455590278
  Currency: "Euro"
  Disc. %: 0
  x Email: "techlead@burstyourideas.com"
  IBAN: ""
  x ID: "00000000F"
  Language: "Spanish"
  Mandate ref.: ""
  Mobile: ""
  x Name: "+34607607191 - Alberto GG"
  P.Method: ""
  x Phone: 34607607191
  Portal visibility: "Default"
  x Postal code: 11130
  x Province: "Miprov"
  Purchases account: ""
  Reference: "93042862-1071-7052-5fd6-fe0999bb0f6d"
  Regime: "General regimen"
  Sales account: ""
  Swift: ""
  Tags: "#develop "
  Type: "Client"
   */

  const rejectedRecords: Array<{ reason: string, data: Record<string, any> }> = [];
  const validRecords: Array<Record<string, any>> = [];

  // Validar y separar registros válidos de rechazados
  data.forEach(item => {
    const hasAccount = item['Account'] !== undefined && item['Account'] !== null && item['Account'] !== '';
    const hasID = item['ID'] !== undefined && item['ID'] !== null && item['ID'] !== '';

    if (!hasAccount && !hasID) {
      rejectedRecords.push({ reason: 'Falta Account e ID', data: item });
    } else if (!hasAccount) {
      rejectedRecords.push({ reason: 'Falta Account', data: item });
    } else if (!hasID) {
      rejectedRecords.push({ reason: 'Falta ID', data: item });
    } else {
      validRecords.push(item);
    }
  });

  // Convertir solo registros válidos
  const convertedData = validRecords.map(item => {
    const clientAccount = getShiftedAccount(item['Account']);
    const { nombre, nombre1, nombre2, razonSocial } = parseNameAndPhone(item['Name']);

    return {
      'CodigoEmpresa': '1',
      'ClienteOProveedor': 'C', // C | P
      'CodigoClienteProveedor': clientAccount,
      'SiglaNacion': item['Country code'],
      'CifDni': item['ID'],
      'CifDniRepresentante': '',
      'CodigoCategoriaCliente_': 'CLI',
      'CifEuropeo': '',
      'Nombre': nombre,
      'Nombre1': nombre1,
      'Nombre2': nombre2,
      'RazonSocial': razonSocial,
      'RazonSocial2': '',
      'ViaPublica': '',
      'Numero1': '',
      'Numero2': '',
      'Escalera': '',
      'Piso': '',
      'Puerta': '',
      'Letra': '',
      'Domicilio': '',
      'CodigoPostal': item['Postal code'],
      'CodigoMunicipio': '',
      'Municipio': '',
      'CodigoProvincia': '',
      'Provincia': item['Province'],
      'CodigoNacion': '',
      'Nacion': '',
      'Telefono': item['Phone'],
      'Telefono2': '',
      'Telefono3': '',
      'Fax': '',
      'Email1': item['Email'],
      'Email2': '',
      'CodigoBanco': '',
      'CodigoAgencia': '',
      'DC': '',
      'CCC': '',
      'IBAN': '',
      'NumeroPlazos': '',
      'DiasPrimerPlazo': '',
      'DiasEntrePlazos': '',
      'DiasFijos1': '',
      'DiasFijos2': '',
      'DiasFijos3': '',
      'DiasRetroceso': '',
      'InicioNoPago': '',
      'FinNoPago': '',
      'ControlarFestivos': '',
      'MesesComerciales': '',
      'Cargo1': '',
      'Cargo2': '',
      'CodigoCanal': '',
      'CodigoComisionista': '',
      'CodigoCondiciones': '',
      'CodigoCuenta': getAccountFromClientAccount(clientAccount),
      'CodigoCuentaEfecto': '',
      'CodigoCuentaImpagado': '',
      'CodigoDepartamento': '',
      'CodigoIdioma_': '',
      'CodigoIva': '',
      'CodigoMotivoBajaClienteLc': '',
      'CodigoRetencion': '',
      'CodigoSigla': '',
      'CodigoTerritorio': '',
      'CodigoTipoEfecto': '',
      'CodigoTransaccion': '',
      'ColaMunicipio': '',
      'Contrapartida': '',
      'Deducible': '',
      'Exclusion347': '',
      'FechaNacimiento': '',
      'IdDelegacion': '',
      'MarcaMenorSinNif': '',
      'MotivoBajaClienteLc': '',
      'NombreRepresentante': '',
      'PersonaFisicaJuridica': '',
      'PuntosSR': '',
      'RemesaHabitual': '',
      'SiglaNacionRepresentante': '',
      'TarifaDescuento': '',
      'TarifaPrecio': '',
      'TarjetaSR': '',
      'TipoCif': '',
      'TipoDocumentoPersona': '',
      '%Descuento': '',
      '%Financiacion': '',
      '%ProntoPago': '',
      '%Rappel': '',
      'Comentario': ''
    }
  });

  return { convertedData, rejectedRecords };
}

export function convertAsientos(data: Array<Record<string, any>>): {
  convertedData: Array<Record<string, any>>,
  rejectedRecords: Array<{ reason: string, data: Record<string, any> }>,
  exclusionStats: ExclusionStats
} {
  /*
  x Account: 40000000
  Account name: "Proveedores euros"
  Checked: "No"
  x Credit: 0
  x Date: 45839.457256944
  x Debit: 0
  x Description: "Compra, 7843b57f-d4f5-4cb7-8f9a-c3db4739dd40, Alberto GG (+34607607191), +34607607191, 01/07/2025"
  x Document: "7843b57f-d4f5-4cb7-8f9a-c3db4739dd40"
  Entry: 8050
  x Line: 1
  Tags: ""
  x Type: "Purchase" | "Collect"
   */

  const rejectedRecords: Array<{ reason: string, data: Record<string, any> }> = [];

  // Inicializar estadísticas de exclusión
  const exclusionStats: ExclusionStats = {
    devDocuments: 0,
    total: 0
  };

  const convertedData = data
    .filter(item => {
      const description = String(item['Description'] || '');
      const document = String(item['Document'] || '');

      // ÚNICO FILTRO: Excluir documentos de desarrollo
      if (isDevDocument(description, document)) {
        exclusionStats.devDocuments++;
        exclusionStats.total++;
        return false;
      }

      return true;
    })
    .map(item => {
      const { ejercicio, periodo } = getYearAndMonthFromExcelDate(item['Date']);

      return {
        'CodigoEmpresa': '1',
        'Ejercicio': ejercicio,
        'NumeroPeriodo': periodo,
        'FechaAsiento': item['Date'],
        'CodigoCuenta': getShiftedAccount(item['Account']),
        'Asiento': item['Entry'],
        'Comentario': item['Description'],
        'Tipo': item['Type'],
        'Documento': item['Document'],
        'CargoAbono': item['Credit'] > 0 ? 'H' : 'D',
        'ImporteAsiento': item['Credit'] > 0 ? item['Credit'] : item['Debit'],
        'Descripcion1': '1',
      };
    });

  return { convertedData, rejectedRecords, exclusionStats };
}

export function convertPlan(data: Array<Record<string, any>>): Array<Record<string, any>> {
  /*
  x Account: 75900000
  Balance: 0
  Credit: 0
  Debit: 0
  Group: "Ventas e ingresos"
  x Name: " Ingresos por servicios diversos"
  Subgroup 1: "Otros ingresos de gestión"
  Subgroup 2: "Ingresos por servicios diversos"
  Subgroup 3: "-"
   */
  return data.map(item => {
    return {
      'CodigoEmpresa': '1',
      'CodigoCuenta': getShiftedAccount(item['Account']),
      'Cuenta': item['Name'],
      'ClienteOProveedor': 'C', // C | P
    }
  });
}
